import { COHORT_GROWTHBOOK_KEYS_MAP } from 'nove8/constants/ab-tests'
import { getGrowthbookVariantData } from 'nove8/helpers/getGrowthbookVariantData'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetGrowthbookVariantData = (): void => {
  const { cohort, growthbook, country } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || state.initialCohort,
      growthbook: state.growthbook,
      country: state.lead?.country || '',
    })),
  )

  useEffect(() => {
    const growthbookKey = COHORT_GROWTHBOOK_KEYS_MAP[cohort]
    const growthbookVariantValue = getGrowthbookVariantData({
      growthbook,
      growthbookKey,
    })

    useZustandStore.setState({
      growthbookVariantData: growthbookVariantValue,
    })
  }, [growthbook, cohort, country])
}
